import list from './list';
import edit from './edit';
import create from './create';
import { isAdmin, isSuperAdmin } from '../../utils';

export default (permissions) => {
  const isVisible = isSuperAdmin(permissions) || isAdmin(permissions);

  return {
    name: 'evidence',
    list: isVisible ? list : null,
    edit: isVisible ? edit : null,
    create: isVisible ? create : null,
    icon: 'search',
    options: {
      menuIndex: 2,
      isHidden: !isVisible,
    },
  };
};
